export default [
  {
    img: require("./images/accident_per_dist.png"),
    des:
      "The amount of mild injuries and serious injuries for each district for 2017",
    alt: "Barcelona most accidents visualization",
    id: 1
  },
  {
    img: require("./images/accident_per_month.png"),
    des: "The total of accidents per month for Barcelona",
    alt: "Barcelona accidents per month visualization",
    id: 2
  },
  {
    img: require("./images/female_vs_male_life_expectancy.png"),
    des: "Male and female life expectancy per year",
    alt: "Barcelona accidents per month visualization",
    id: 3
  },
  {
    img: require("./images/air_quality.png"),
    des: "The higher the amount of elements in the air the worst the quality",
    alt: "Barcelona accidents per month visualization",
    id: 4
  },
  {
    img: require("./images/life_expectancy.png"),
    des: "Life expectancy for each age group and district",
    alt: "Barcelona accidents per month visualization",
    id: 5
  },
  {
    img: require("./images/unemployment_total.png"),
    des: "The total of unemployment during 2017 per district",
    alt: "Barcelona accidents per month visualization",
    id: 6
  },
  {
    img: require("./images/international_people_to.png"),
    des: "Amount of international people that come to each district",
    alt: "Barcelona accidents per month visualization",
    id: 7
  },
  {
    img: require("./images/transportation.png"),
    des: "Total records of most used form of transportation",
    alt: "Barcelona accidents per month visualization",
    id: 8
  },
  {
    img: require("./images/total_accident.png"),
    des: "The total accident for each district",
    alt: "Barcelona accidents per month visualization",
    id: 9
  },
  {
    img: require("./images/birth_rate.png"),
    des: "Birth rate of each district",
    alt: "Barcelona accidents per month visualization",
    id: 9
  }
];
